import { Serializable } from '@/models/core/serializable';

export class SchoolClassTrendResults implements Serializable<SchoolClassTrendResults> {
  data: SchoolClassTrendResult[];

  deserialize(input: any): SchoolClassTrendResults {
    if (input.data && input.data.length > 0) {
      this.data = input.data.map((schoolClassTrendResult: SchoolClassTrendResult) => new SchoolClassTrendResult().deserialize(schoolClassTrendResult));
    }
    return this;
  }
}

export class SchoolClassTrendResult implements Serializable<SchoolClassTrendResult> {
  highCompetencyText: string;
  potentialCompetencyText: string;
  schoolClassID: number;
  schoolClassName: string;
  trendText: string;

  deserialize(input: any): SchoolClassTrendResult {
    this.highCompetencyText = input.highCompetencyText;
    this.potentialCompetencyText = input.potentialCompetencyText;
    this.schoolClassID = input.schoolClassID;
    this.schoolClassName = input.schoolClassName;
    this.trendText = input.trendText;
    return this;
  }
}
